/**
 * Badge presentation for a profile's membership_plan cache column
 * (`adn_profiles.membership_plan`), kept in sync by the org's Stripe
 * subscription webhook per ADN-2135.
 */
export interface MembershipPlanBadge {
  icon: string;
  badge: string;
  label: string;
}

export function getMembershipPlanBadge(plan: 'core' | 'pro'): MembershipPlanBadge {
  if (plan === 'pro') {
    return { icon: 'bi bi-star-fill', badge: 'badge bg-primary text-light', label: 'Pro' };
  }
  return { icon: 'bi bi-circle', badge: 'badge bg-secondary', label: 'Core' };
}
